import { BaseStore } from '~web/store/base/base-store';
import {
  RequiresAuthenticationParameters,
  ResetPasswordQueryParameters,
} from '~web/view/pages/parameters';

/**
 * Possible actions on Discover page
 */
export enum DiscoverPageAction {
  RESET_PASSWORD,
  REQUIRES_AUTHENTICATION,
}

/**
 * Possible parameters for the actions on Discover page
 */
interface DiscoverActionParameters
  extends ResetPasswordQueryParameters,
    RequiresAuthenticationParameters {}

export class DiscoverActionStore extends BaseStore {
  pageAction: DiscoverPageAction;
  parameters: DiscoverActionParameters;

  constructor() {
    super();
    this.clear();
  }

  initialize(pageAction: DiscoverPageAction, parameters?: DiscoverActionParameters): void {
    this.pageAction = pageAction;
    this.parameters = parameters;
  }

  clear(): void {
    this.pageAction = undefined;
    this.parameters = undefined;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/store/discover/discover-action-store.ts